import ClientAuthLayout from "../../layout/client/ClientAuthLayout";
import ClientAuth from "../../view/client/auth/CleintAuth";
import ClientPublicRoute from "./clientPublicRoute";

const clientAuthRoute = {
  path: "/client/auth",
  element: (
    <ClientPublicRoute>
      <ClientAuthLayout />
    </ClientPublicRoute>
  ),
  children: [
    {
      path: "/client/auth",
      element: (
        <ClientPublicRoute>
          <ClientAuth />
        </ClientPublicRoute>
      ),
    },
  ],
};

export default clientAuthRoute;
